export const URL_PARAMETER = 'clickid';
export const CONVERSION_TRACKING_ID_SALE = 3712;
export const CONVERSION_TRACKING_ID_EMAIL_LEAD = 5749;
